import { Statistic } from 'antd';
import React from 'react';
import CurrencyIcon from '../../Common/CurrencyIcon';
import './InfoStatComponent.styles.scss';

const InfoStatComponent = ({ className, value, valueOf, title, currency, icon }) => {
  return (
    <div className={`${className}`}>
      <div className="common_card admin_stats_cards p-3 h-100">
        <h5 className="admin_stats_cards--title">{title}</h5>
        <h4 className="admin_stats_cards--value">
          {currency}<Statistic value={value}
            className="custom_number_format"/>
          <span>{valueOf}</span>
          {/* <i>{icon}</i> */}
        </h4>
      </div>
    </div>
  );
};

export default InfoStatComponent;
